import { WebGivingPaymentMethodModel } from '../webgiving-generated';

export function paymentMethodAriaLabel(paymentMethod: WebGivingPaymentMethodModel) {
	let {
		DisplayReference: displayReference,
		BrandSvgLogo: brand,
		Nickname: nickname,
		PaymentMethodType: type,
		CardExpiryMonth: expiryMonth,
		CardExpiryYear: expiryYear,
	} = paymentMethod;

	displayReference = paymentMethod.DisplayReference.replace(/\s/g, '');
	displayReference = displayReference.replace(/•{2,}/g, '•••');

	let expiry = '';
	if (type === 1) {
		expiry = ` expires ${expiryMonth} / ${expiryYear}`;
	}

	return `${nickname}, ${brand} ${displayReference} ${expiry}`;
}
